import { createActionGroup, emptyProps } from '@ngrx/store';

export const InsuranceActions = createActionGroup({
    source: 'Margin Calculator - Insurance',
    events: {
        revealInsuranceDetailsClicked: emptyProps()
    }
});
